import cn from 'classnames'

import { FunctionComponentType } from '@interfaces/commons/FunctionComponent'
import { TableProps, TableRowProps } from './interface'

export function Table({ children, className, onScroll }: TableProps) {
  return (
    <div className={cn('overflow-y-auto', className)} onScroll={onScroll}>
      {children}
    </div>
  )
}

Table.Header = function ({ children, className }: FunctionComponentType) {
  return (
    <div className={cn('text-xs text-secondary-1 font-bold', className)}>
      {children}
    </div>
  )
}

Table.Row = function ({ children, className, onClick }: TableRowProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-[1fr_150px_150px_150px_220px_100px]',
        {
          'cursor-pointer hover:bg-blue-2 dark:hover:bg-dark': !!onClick,
        },
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

Table.Column = function ({ children, className }: FunctionComponentType) {
  return (
    <div
      className={cn(
        'text-[14px] text-secondary dark:text-white-2 font-light',
        className
      )}
    >
      {children}
    </div>
  )
}

Table.Footer = function ({ children, className }: FunctionComponentType) {
  return (
    <div className={cn('text-[14px] font-bold bg-blue-2', className)}>
      {children}
    </div>
  )
}
